/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Input, OnInit, signal, inject } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { FormValidationCheckerService } from '../_shared/services/form-validation-checker.service';
import { LabelComponent } from '../label/label.component';

@Component({
    selector: 'sirius-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, LabelComponent]
})
export class InputComponent implements ControlValueAccessor, OnInit {
    private _ngControl = inject(NgControl, { optional: true, self: true });
    validationService = inject(FormValidationCheckerService);

    @Input() label = '';
    @Input() type = '';
    @Input() id = '';
    @Input() name = '';
    @Input() identifier = '';

    value = '';

    protected readonly focused = signal(false);
    protected readonly labelSize = computed<'s' | 'l'>(() => (this.focused() || !!this.control?.value ? 's' : 'l'));

    private _valid = new BehaviorSubject<boolean>(true);
    valid$ = this._valid.asObservable();

    get control() {
        return this._ngControl?.control as FormControl;
    }

    onChangeCallback = (value: string) => {
        //empty
    };

    onTouchedCallback = () => {
        //empty
    };

    constructor() {
        const _ngControl = this._ngControl;

        if (_ngControl) {
            _ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.control.statusChanges.subscribe((status) => {
            this._valid.next(status !== 'INVALID' ? true : false);
        });
    }

    onChange(e: Event) {
        const tar = e.target as HTMLInputElement;

        this.onChangeCallback(tar.value);
    }

    writeValue(value: string) {
        this.value = value;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) this.control?.disable();
    }
}
